import { useMediaQuery } from '@mui/material';
import { useMemo } from 'react';

const useGridElementsCount = () => {
  const isLaptop = useMediaQuery('(max-width: 1440px)');
  const isTablet = useMediaQuery('(max-width: 1024px)');
  const isMobile = useMediaQuery('(max-width: 768px)');

  return useMemo(() => {
    if (isMobile) return 1;
    if (isTablet) return 2;
    if (isLaptop) return 3;
    return 4;
  }, [isLaptop, isMobile, isTablet]);
};

export default useGridElementsCount;
